import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap"
import { ContentBody } from "../../styled"
import { CoursesTable } from "../../components/table-courses";

import { MdOutlineSchool } from "react-icons/md";
import { Modal } from "../../../../components/modal";

import { changeStatusCourse, deleteCourse, getCourses, publishCourse } from "../../../../services/manager/admin/courses.service";
import { PaginationList } from "../../../../components/pagination";

export const MyCoursesList = (): JSX.Element => {
  const history = useHistory();
  const { t: translation } = useTranslation();

  //Pagination
  const [totalItens, setTotalItens] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  //Ordering
  const [sortOrder, setSortOrder] = useState(1);
  const [sortField, setSortField] = useState("name");

  const [loadingTable, setLoadingTable] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [showUnpublishCourse, setShowUnpublishCourse] = useState<boolean>(false);
  const [showInactiveCourse, setShowInactiveCourse] = useState<boolean>(false);
  const [showRemoveCourseModal, setShowRemoveCourseModal] = useState<boolean>(false);
  const [courseSelected, setCourseSelected] = useState<any>();
  const [courses, setCourses] = useState<any>([]);

  const treeTableConfig = [
    {field: 'name', header: 'Nome', sortable: true, style: {textAlign: 'left', width: '35%'}},
    {field: 'is_location', className: "d-none-lg-table d-none-md-table d-none-xs-table", localTemplate: true, header: 'Local', style: {width: '12%', textAlign: 'center'}}, 
    {field: 'type_course', className: "d-none-md-table d-none-xs-table", typeCourseTemplate: true, header: 'Modalidade', sortable: true, style: {width: '12%', textAlign: 'center'}},
    {field: 'workload', className: "d-none-xs-table", workloadTemplate: true,  header: 'Carga Horária', style: {width: '12%', textAlign: 'center'}},
    {field: 'steps_count', className: "d-none-xs-table", header: 'Fases', style: {width: '10%', textAlign: 'center'}}, 
    {field: 'disciplines_count', className: "d-none-lg-table d-none-md-table d-none-xs-table", header: 'Qtd de disciplinas', style: {width: '15%', textAlign: 'center'}},
    {field: 'actions', header: '', actionsTemplate: true, sortable: false, style: {textAlign: 'center', width: '7%'}},
  ]

  const handleTableSort = useCallback((event: any) => {
    let order = event.sortOrder > 0 ? event.sortField : '-' + event.sortField;
    
    setSortOrder(event.sortOrder);
    setSortField(event.sortField);
    getCoursesList(`ordering=${order}`);
  }, []);

  const handlePublishCourse = (course: any, action: string) => {
    if (action === "unpublish") {
      setCourseSelected(course.data)
      setShowUnpublishCourse(true)
    } else if ("publish") {
      if (course.data.disciplines_count === 0) {
        toast.warning(
          <div>
            <h6 className="text-white mb-1"><b>Não foi possível publicar o curso.</b></h6>
            <p className="text-white mb-0">Antes de publicar um curso você deve adicionar as disciplinas que irão compor a matriz.</p>
          </div>
        , { icon: false })
        return
      } else {
        publishCourse(course.data.id, true).then(() => {
          toast.success('Curso publicado com sucesso!');
          getCoursesList();
        }).catch((err: any) => {
          toast.error(err.response.data.message);
          setLoadingModal(false)
        })
      }
    }
  }

  const handleChangeStatusCourse = (course?: any) => {
    if (course.data.is_active) {
      setCourseSelected(course.data)
      setShowInactiveCourse(true)
    } else {
      changeStatusCourse(course.data.id, true).then(() => {
        toast.success('Curso reativado com sucesso!')
        setLoadingModal(false)
        getCoursesList();
      }).catch(() => {
        toast.error('Ocorreu um erro ao reativar este curso. Tente novamente.')
        setLoadingModal(false)
      })
    }
  }

  const handleDeleteCourse = (course?: any) => {
    setCourseSelected(course.data)
    setShowRemoveCourseModal(true)
  }

  const submitInactivateCourse = () => {
    setLoadingModal(true)
    changeStatusCourse(courseSelected.id, false).then(() => {
      toast.success('Curso inativado com sucesso!')
      setLoadingModal(false)
      setShowInactiveCourse(false)
      getCoursesList();
    }).catch(() => {
      toast.error('Ocorreu um erro ao inativar este curso. Tente novamente.')
      setLoadingModal(false)
    })
  }

  const submitUnpublishCourse = () => {
    setLoadingModal(true)
    publishCourse(courseSelected.id, false).then(() => {
      toast.success('Curso despublicado com sucesso!');
      getCoursesList();
      setLoadingModal(false)
      setShowUnpublishCourse(false)
    }).catch((err: any) => {
      toast.error(err.response.data.message);
      setLoadingModal(false)
    })
  }

  const submitDeleteCourse = () => {
    setLoadingModal(true)
    deleteCourse(courseSelected.id).then(() => {
      toast.success('Curso removido com sucesso!')
      setLoadingModal(false)
      setShowRemoveCourseModal(false)
      getCoursesList();
    }).catch(() => {
      toast.success('Ocorreu um erro ao remover este curso. Tente novamente.')
      setLoadingModal(false)
    })
  }

  const handlePageChange = (event?: any) => {
    // if (currentPage !== event) {
    //   switch (key) {
    //     case 'opened':
    //       getOpenedList(`page=${event}&q=${query}`);
    //     break;

    //     case 'finished':
    //       getFinishedList(`page=${event}&q=${query}`);
    //     break;
        
    //     default:
    //       getRequestsList(`page=${event}&q=${query}`)
    //   }
      setCurrentPage(event)
    // }
  }

  const getCoursesList = (q?: string) => {
    setLoadingTable(true)

    getCourses(q).then((response: any) => {
      let arr: any = []
      response.results.map((item: any) => {
        let obj = {
          data: item
        }
        arr.push(obj)
      })
      setCourses(arr)
    }).finally(() => {
      setLoadingTable(false)
    })
  }

  useEffect(() => {
    getCoursesList()
  }, [])

  return (
    <Container fluid>
      <Row className="mb-4">
        <Col lg={10}>
          <h4><b>Meus cursos</b></h4>
          <p className="mb-0 text-black font-light">Crie uma matriz curricular com base nas disciplinas que estiverem cadastradas na DStore.</p>
        </Col>
        <Col className="text-end mr-2">
          <Button onClick={() => history.push('new-course')}>Novo curso</Button>
        </Col>
      </Row>
      {
        loadingTable ? (
          <div className="loading-container mt-4">
            <Spinner 
              animation="border" 
              variant="primary" 
              style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }} 
            />
          </div>
        ) : (
          <ContentBody>
            {
              courses && courses.length > 0 ? (
                <CoursesTable
                  treeFields={treeTableConfig} 
                  nodes={courses}
                  sortField={sortField} 
                  sortOrder={sortOrder}
                  handleTableSort={handleTableSort}
                  handleChangeStatusCourse={handleChangeStatusCourse}
                  handleDeleteCourse={handleDeleteCourse}
                  handlePublishCourse={handlePublishCourse}
                />
              ) : (
                <div className="text-center" style={{ marginTop: '20vh', color: '#D9D9D9' }}>
                  <MdOutlineSchool size={75}/>
                  <h4 className="text-grey">Nenhum curso criado</h4>
                </div>
              )
            }
          </ContentBody>
        )
      }

      <Row className="mt-4">
        {
          !loadingTable && courses.length > 0 ? (
            <PaginationList currentPage={currentPage} totalItems={totalItens} onPageChange={handlePageChange}/>
          ) : (<></>)
        }
      </Row>

      <Modal 
        headerTitle="Aviso"
        submitButtonText={translation('unpublish')}
        show={showUnpublishCourse}
        onHide={() => setShowUnpublishCourse(false)}
        onSubmit={submitUnpublishCourse}
        variant="confirm-modal-default"
        loading={loadingModal}
      >
        <p>Tem certeza que deseja despublicar o curso<b className="span-ellipsis">{courseSelected ? courseSelected.name : ""}?</b></p>
        
        {
          courseSelected && courseSelected.users_count > 0 &&
          <p>O curso está sendo utilizado por {courseSelected.users_count} usuários.</p>
        }
      </Modal>

      <Modal 
        headerTitle="Aviso"
        submitButtonText={translation('manager.user.inactivate')}
        show={showInactiveCourse}
        onHide={() => setShowInactiveCourse(false)}
        onSubmit={submitInactivateCourse}
        variant="confirm-modal-default"
        loading={loadingModal}
      >
        <p>Tem certeza que deseja inativar o curso<b className="span-ellipsis">{courseSelected ? courseSelected.name : ""}?</b></p>
        {
          courseSelected && courseSelected.users_count > 0 &&
          <p>O curso está sendo utilizado por {courseSelected.users_count} usuários.</p>
        }
      </Modal>

      <Modal 
        headerTitle="Aviso" 
        submitButtonText={translation('manager.links.remove')}
        show={showRemoveCourseModal} 
        onHide={() => setShowRemoveCourseModal(false)}
        onSubmit={submitDeleteCourse} 
        variant="confirm-modal"
        loading={loadingModal}
      >
        <p>
          Tem certeza que deseja excluir o curso <b className="span-ellipsis">{courseSelected ? courseSelected.name : ""}?</b>
        </p>
      </Modal>
    </Container>
  )
}